import { Component } from "react";
import './counter.scss';

class Counter extends Component{
    constructor(props) {
        super(props);
        this.state = {
            counter: this.props.counter
        }
    }
    incCount = () => {
        this.setState(state => ({
            counter: state.counter + 1
        }))
    }
    decCount = () => {
        this.setState(state => ({
            counter: state.counter - 1
        }))
    }
    defCount = () => {
        this.setState({
            counter: this.props.counter
        })
    }
    rndCount = () => {
        this.setState({
          counter: +(Math.random() * (50 - -50) + -50).toFixed(0)
        })
      }
    render() {
        const { counter } = this.state;
        return (
            <div className="counter" id="counter" >
                <h2 className="counter__title">Counter</h2>
                <div className="counter__container">
                    <button className="counter__btn counter__plus" onClick={this.incCount}> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-patch-plus-fill" viewBox="0 0 16 16">
                            <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM8.5 6v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"/>
                        </svg>
                    </button>
                    <button className="counter__btn counter__minus" onClick={this.decCount}> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-patch-minus-fill" viewBox="0 0 16 16">
                            <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"/>
                        </svg>    
                    </button>
                    <button className="counter__btn counter__default" onClick={this.defCount}>Default</button>
                    <button className="counter__btn counter__random" onClick={this.rndCount}>Random</button>
                </div>
                <div className="counter__num"> {counter} </div>
            </div>
        )
    }
}

export default Counter;